import { http, HttpResponse } from 'msw';

import { FinalOffer } from '../../types/OfferTypes';

const offersResponse: FinalOffer = {
    selected: {
        offerId: '12345',
        offerType: 'CASH',
        status: 'APPROVED',
        riskColor: 'GREEN',
        outcomeReasons: ['INTERNAL_CREDIT_SCORING'],
        policyRulesHits: [
            {
                code: 'string',
                desc: 'string',
                canOverride: true,
                isOverridden: true,
            },
        ],
        approved: {
            amount: 50000,
            currency: 'NOK',
        },
        preliminaryDisbursement: {
            amount: 0,
            currency: '',
        },
        requiredConsolidation: {
            amount: 0,
            currency: '',
        },
        monthlyInstallment: {
            amount: 1200,
            currency: 'NOK',
        },
        tenor: {
            months: 35,
            years: 3,
            yearsMonthsRemainder: -1,
        },
        effectiveInterest: {
            percent: 25.2,
            decimal: 0.252,
        },
        nominalInterest: {
            percent: 24.2,
            decimal: 0.252,
        },
        existingLoan: undefined,
        adminFee: {
            name: '',
            feeCode: '',
            labelCode: '',
            amount: 0,
            currency: '',
        },
        setupFee: {
            name: '',
            feeCode: '',
            labelCode: '',
            amount: 0,
            currency: '',
        },
        totalLoanCost: {
            amount: 0,
            currency: '',
        },
        totalRepayment: {
            amount: 0,
            currency: '',
        },
        requiredComplementaryInformation: [
            {
                applicantType: 'applicant',
                documentStatus: 'PENDING',
                complementaryInformationType: 'ID',
                documentId: 'string',
            },
        ],
        consolidations: [
            {
                kidNumber: '',
                accountType: 'REPAYMENT_LOANS',
                creditorName: 'HANDELSBANKEN',
                internalId: '0d0d063d-f3ae-48d1-a25c-da64e32c413d:c0a05b93',
                currentBalance: {
                    amount: 159422.0,
                    currency: 'NOK',
                },
                nominalInterestRate: 17.74,
                tenor: 108,
                accountNumber: '15030250459',
                applicantType: 'MAIN',
            },
            {
                kidNumber: '',
                accountType: 'CREDIT_FACILITY',
                creditorName: 'SWEDBANK',
                internalId: '77fe044e-0340-4a7f-b504-f235cf67c0a4:d8c2225a',
                currentBalance: {
                    amount: 79000.0,
                    currency: 'NOK',
                },
                nominalInterestRate: 18.6,
                tenor: 0,
                accountNumber: '15030250459',
                applicantType: 'CO',
            },
            {
                kidNumber: '',
                accountType: 'REPAYMENT_LOANS',
                creditorName: 'NORDEA',
                internalId: '187e1e0c-dcb7-426a-b269-5a91c12ba6ec:c1594639',
                currentBalance: {
                    amount: 25653.0,
                    currency: 'NOK',
                },
                nominalInterestRate: 14.0,
                tenor: 51,
                accountNumber: '15030250459',
                applicantType: 'MAIN',
            },
        ],
    },
    current: {
        offerId: '12345',
        offerType: 'CASH',
        status: 'APPROVED',
        riskColor: 'GREEN',
        outcomeReasons: ['INTERNAL_CREDIT_SCORING'],
        policyRulesHits: [
            {
                code: 'string',
                desc: 'string',
                canOverride: true,
                isOverridden: true,
            },
        ],
        approved: {
            amount: 40000,
            currency: 'NOK',
        },
        preliminaryDisbursement: {
            amount: 0,
            currency: '',
        },
        requiredConsolidation: {
            amount: 0,
            currency: '',
        },
        monthlyInstallment: {
            amount: 1200,
            currency: 'NOK',
        },
        tenor: {
            months: 35,
            years: 3,
            yearsMonthsRemainder: -1,
        },
        effectiveInterest: {
            percent: 25.2,
            decimal: 0.252,
        },
        nominalInterest: {
            percent: 24.2,
            decimal: 0.252,
        },
        existingLoan: undefined,
        adminFee: {
            name: '',
            feeCode: '',
            labelCode: '',
            amount: 0,
            currency: '',
        },
        setupFee: {
            name: '',
            feeCode: '',
            labelCode: '',
            amount: 0,
            currency: '',
        },
        totalLoanCost: {
            amount: 0,
            currency: '',
        },
        totalRepayment: {
            amount: 0,
            currency: '',
        },
        requiredComplementaryInformation: [
            {
                applicantType: 'applicant',
                documentStatus: 'PENDING',
                complementaryInformationType: 'ID',
                documentId: 'string',
            },
        ],
        consolidations: [
            {
                kidNumber: '',
                accountType: 'REPAYMENT_LOANS',
                creditorName: 'HANDELSBANKEN',
                internalId: '0d0d063d-f3ae-48d1-a25c-da64e32c413d:c0a05b93',
                currentBalance: {
                    amount: 159422.0,
                    currency: 'NOK',
                },
                nominalInterestRate: 17.74,
                tenor: 108,
                accountNumber: '15030250459',
                applicantType: 'MAIN',
            },
            {
                kidNumber: '',
                accountType: 'CREDIT_FACILITY',
                creditorName: 'SWEDBANK',
                internalId: '77fe044e-0340-4a7f-b504-f235cf67c0a4:d8c2225a',
                currentBalance: {
                    amount: 79000.0,
                    currency: 'NOK',
                },
                nominalInterestRate: 18.6,
                tenor: 0,
                accountNumber: '15030250459',
                applicantType: 'CO',
            },
            {
                kidNumber: '',
                accountType: 'REPAYMENT_LOANS',
                creditorName: 'NORDEA',
                internalId: '187e1e0c-dcb7-426a-b269-5a91c12ba6ec:c1594639',
                currentBalance: {
                    amount: 25653.0,
                    currency: 'NOK',
                },
                nominalInterestRate: 14.0,
                tenor: 51,
                accountNumber: '15030250459',
                applicantType: 'MAIN',
                consolidationType: 'PARTIAL',
                consolidationAmount: {
                    amount: 10000,
                    currency: 'NOK',
                },
            },
        ],
    },
};

export const getFinalOffersHandlers = [
    http.get('*/api/cl_loanapp_proxy_service/v1/:countryCode/offers/:arn/final_offers', async () => {
        return HttpResponse.json(offersResponse);
    }),
];
